/**
 * @generated SignedSource<<cd043c7ecc3cc837935555bca3402a93>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Heart_item$data = {
  readonly portfolioItemDetails: {
    readonly likes: number | null;
  } | null;
  readonly " $fragmentType": "Heart_item";
};
export type Heart_item$key = {
  readonly " $data"?: Heart_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"Heart_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Heart_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioItemDetailsType",
      "kind": "LinkedField",
      "name": "portfolioItemDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "likes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0465939d9f340770b76b408f34b1d73b";

export default node;
